module.exports = __webpack_public_path__ + "img/logo_cuseremp_black.15204934.svg";